<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">问卷调查</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-select v-model="queryForm.semesterCode" placeholder="学年学期名称"
                                   style="width: 90%;margin-left: 5%;" filterable @change="queryList">
                            <el-option v-for="item in comboData.semester" :key="item.comboValue" :label="item.comboName"
                                       :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有可查看的评教信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">调查名称：</label>{{ item.title }}</p>
                        <p><label for="">开放时间：</label>{{ item.beginDate }}</p>
                        <p><label for="">结束时间：</label>{{ item.endDate }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button type="primary" @click="openQue(item)">操作</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍后...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="title" v-if="flag.infoFlag"
                       :visible.sync="flag.infoFlag" :close-on-click-modal=false :show-close=false
                       @close="closeDialog()" :key="key">
                <el-form ref="form" :model="form" label-width="84px" label-position="left" width="100%">
                    <div
                        style="margin-left: 20px;width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        <el-form-item label="教师姓名">
                            {{ infoData.teaInfo[pageNum.teaPageNum - 1].teaName }}
                        </el-form-item>
                        <el-tooltip class="item" effect="dark"
                                    :content="infoData.teaInfo[pageNum.teaPageNum-1].courseName"
                                    placement="top">
                            <el-form-item label="课程" style="margin-top: -10px;">
                                {{ parseStr(infoData.teaInfo[pageNum.teaPageNum - 1].courseName) }}
                            </el-form-item>
                        </el-tooltip>
                    </div>

                    <el-scrollbar id="pfMainDialogScroll" ref="stuMainDialogScroll">
                        <div ref="stuRef">
                            <div ref="stuWindowRef">
                                <template v-for="(item,index) in infoData.allQuestion ">
                                    <div :class='"divider"+index'>
                                        <el-divider></el-divider>
                                    </div>

                                    <el-form label-position="top" width="100%">
                                        <el-form-item>
                                            {{ index + 1 + '.' }}{{ item.questionContent }}
                                        </el-form-item>
                                    </el-form>

                                    <el-form-item label="评分" :prop="'_05['+(pageNum.teaPageNum-1)+']['+index+']'"
                                                  :rules="[{required: true, message: ' '}]">
                                        <el-select v-if="item.questionType === '01'" v-model="form._05[pageNum.teaPageNum-1][index]" :disabled="ywcFlag" clearable>
                                            <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                       :label="list.comboName" :value="list.comboValue">
                                            </el-option>
                                        </el-select>

                                        <el-select v-if="item.questionType === '02'" v-model="form._05[pageNum.teaPageNum-1][index]" :disabled="ywcFlag" multiple clearable>
                                            <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                       :label="list.comboName" :value="list.comboValue">
                                            </el-option>
                                        </el-select>

                                        <el-select v-if="item.questionType === '05'" v-model="form._05[pageNum.teaPageNum-1][index]" :disabled="ywcFlag" clearable>
                                            <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                       :label="list.comboValue" :value="list.comboValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </div>
                        </div>
                    </el-scrollbar>
                </el-form>

                <div id="pfInputDialogScroll" style="text-align: center;">
                    <div>
                        <el-pagination ref="pagin" prev-text='上一页' next-text='下一页'
                                       @current-change="getTeaPageNum" layout="prev, slot, next"
                                       :total="parseInt(infoData.teaInfo.length+'0')"
                                       :current-page.sync="pageNum.pageNumColumn">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <span>
                                <span class="leftSpan">{{ pageNum.teaPageNum }}</span>/<span>{{
                                    infoData.teaInfo.length
                                }}</span>
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </el-pagination>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="submit('05')" v-show="subFlag" type="success">提 交</el-button>
                    <el-button style="margin-left: 10px;" type="danger" @click="back">退 出</el-button>
                    <el-button style="margin-left: 10px;" @click="clear" type="warning"
                               v-show="flag.infoFlag && clearFlag">重 置
                    </el-button>
                </div>
            </el-dialog>

        </div>

    </div>
</template>
<script>
import {globalConfig} from 'static/config'
import {confirmMsg, showNotify} from 'utils/message';

export default {
    data() {
        return {
            comboData: {
                semester: []
            },
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                visitType: 'mobile',
                semesterCode: '',
                userCode: '',
                role: ''
            },
            tableData: [],
            currentPage: 1,
            limit: 10,
            total: null,
            tableLoading: true,
            selectRowData: null,
            mainTableHeight: 500,
            user: {
                userCode: "",
                userName: "",
                userRoles: "",
            },
            title: '',
            id: '',
            quesState: '',
            infoData: {
                teaInfo: [],
                allQuestion: []
            },
            doFlag: false,
            clearFlag: false,
            subFlag: false,
            loadingMask: null,

            flag: {
                infoFlag: false
            },
            form: {
                _05: []
            },

            pageNum: {
                teaPageNum: 1,
                pageNumRow: 1,
                pageNumColumn: 1
            },
            laterSub: false,
            key: 0,
            ywcFlag: false
        };
    },
    mounted() {
        this.userInfo()
    },
    methods: {
        parseStr(str) {
            if (str.length > 12) {
                return str.substring(0, 13) + "..."
            } else {
                return str
            }
        },
        //清空答案
        clear() {
            confirmMsg('是否确定重置答案?', 'el-message-box-mobile').then(() => {
                for (let i = 0; i < this.form._05.length; i++) {
                    for (let j = 0; j < this.form._05[i].length; j++) {
                        this.form._05[i][j] = ''
                    }
                }
                this.key++;
            });
        },
        closeDialog() {
            this.form._05 = [];
            this.laterSub = false;
            this.pageNum.teaPageNum = 1
            this.pageNum.pageNumRow = 1
            this.pageNum.pageNumColumn = 1
            for (let i = 0; i < this.form._05.length; i++) {
                for (let j = 0; j < this.form._05[i].length; j++) {
                    this.form._05[i][j] = ''
                }
            }
            this.key++;
        },
        //提交问卷
        submit() {
            confirmMsg('当前问卷已提交' + this.infoData.answerTime + '次,共可提交' + this.infoData.quesAnswerTime + '次,是否确定提交问卷？', 'el-message-box-mobile').then(() => {

                for (let i = 0; i < this.infoData.repetition.length; i++) {
                    let arr = []
                    for (let j = 0; j < this.infoData.teaInfo.length; j++) {
                        if (this.infoData.teaInfo[j].courseCode == this.infoData.repetition[i]) {
                            arr.push(j)
                        }
                    }

                    let str = ""
                    arr.forEach(item => {
                        str += item + ":";
                        for (let j = 0; j < this.form._05[item].length; j++) {
                            str += this.form._05[item][j]
                        }
                        str += "@"
                    })

                    str = str.slice(0, -1);
                    let split = str.split("@");
                    let flag = false
                    let tempIndex = 0
                    for (let j = 0; j < split.length; j++) {
                        let split2 = split[j].split(":");
                        if(split2[1].length == this.infoData.allQuestion.length){
                            flag = true
                            tempIndex = j
                            break
                        }
                    }

                    if(flag){
                        for (let j = 0; j < split.length; j++) {
                            if(tempIndex != j){
                                let split2 = split[j].split(":");
                                if(split2[1].length == 0){
                                    for (let k = 0; k < this.form._05[split2[0]].length; k++) {
                                        this.form._05[split2[0]][k] = " "
                                    }
                                }
                            }
                        }
                    }
                }

                let total = this.infoData.teaInfo.length * this.infoData.allQuestion.length
                let num = 0;
                for (let i = 0; i < this.form._05.length; i++) {
                    for (let j = 0; j < this.form._05[i].length; j++) {
                        if(this.form._05[i][j] != ''){
                            num++;
                        }
                    }
                }
                if(total != num){
                    this.laterSub = true
                    this.changePageColor()
                    this.$alert("请完成所有题目后重新提交", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                    this.$refs.form.validate();
                    return;
                }

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.showLoadingMask("提交中,请稍后...");
                        let answer = '';
                        for (let i = 0; i < this.infoData.teaInfo.length; i++) {
                            for (let j = 0; j < this.infoData.allQuestion.length; j++) {
                                answer += this.infoData.allQuestion[j].questionId + '@@@';
                                answer += this.infoData.teaInfo[i].teaCode + ':::' + this.infoData.teaInfo[i].teaName + '///'
                                answer += this.form._05[i][j]
                                answer += '###'
                            }
                        }
                        let formData = new FormData();
                        formData.append('id', this.infoData.basic.id);
                        formData.append('type', '05');
                        formData.append('userCode', this.user.userCode);
                        formData.append('answer', answer);

                        this.$api.evaluateManage.questionnaireSurvey.submit({
                            data: formData
                        }).then((res) => {
                            let state = res.data.data;
                            switch (state) {
                                case 'Success':
                                    this.flag.infoFlag = false;
                                    this.doFlag = false
                                    this.clearFlag = false
                                    this.subFlag = false
                                    this.form._05 = []
                                    showNotify('成功', '提交成功', 'success', 1500);
                                    this.queryList()
                                    break;
                                default:
                                    showNotify('错误', '提交失败', 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            console.log(err);
                        });

                        this.closeLoadingMask();

                    } else {
                        this.laterSub = true
                        this.changePageColor()
                        this.$alert("请完成所有题目后重新提交", "提示", {
                            confirmButtonText: "确定",
                            customClass: 'el-message-box-mobile',
                        });
                        return false;
                    }
                });

            });
        },
        getTeaPageNum(val) {
            this.pageNum.teaPageNum = val;
            if (this.laterSub) {
                this.changePageColor(val)
            }

            this.$refs.stuMainDialogScroll.wrap.scrollTop = 0;
        },
        //提交时如果为空,页码变红
        changePageColor() {
            let set = new Set();
            for (var i = 0; i < this.form._05.length; i++) {
                for (var j = 0; j < this.form._05[i].length; j++) {
                    if (this.form._05[i][j] == '') {
                        set.add(i)
                    }
                }
            }
            let arr = Array.from(set)

            let ind = arr.findIndex(item => {
                return item == this.pageNum.teaPageNum - 1
            })

            if (ind != -1) {
                this.$refs.pagin.$el.childNodes[1].getElementsByClassName("leftSpan")[0].style.color = 'red'
            } else {
                this.$refs.pagin.$el.childNodes[1].getElementsByClassName("leftSpan")[0].style.color = 'black'
            }
        },
        //打开问卷
        openQue(rowData) {
            this.title = rowData.title
            this.id = rowData.id
            // if (this.queryForm.role === 'tea') {
            //     this.title += '统计'
            // }
            //判断学生打开调查问卷，老师打开调查问卷统计
            let form = {
                'id': rowData.id,
                'userCode': this.queryForm.userCode,
                'type': rowData.type
            }
            if (this.queryForm.role === 'stu') {
                this.quesState = rowData.state
                // form.userCode = '20225052010101'
                this.loadInfo(form)
            }
            // if (this.queryForm.role === 'tea') {
            //     this.loadStatistics(form)
            // }
        },
        loadInfo(form) {
            this.showLoadingMask("问卷信息加载中,请稍候...");

            this.$api.evaluateManage.questionnaireSurvey.loadInfo({
                data: form
            }).then((res) => {
                this.infoData = res.data.data


                if (parseInt(this.infoData.answerTime) < parseInt(this.infoData.quesAnswerTime)) {
                    if (this.infoData.answerTime === '0') {
                        this.doFlag = '0'
                    } else {
                        this.doFlag = '1'
                    }

                    if (this.quesState === '1' || this.quesState === '2') {
                        this.clearFlag = true;
                        this.subFlag = true
                    }
                } else {
                    this.doFlag = '2'
                }

                if (this.quesState === '3' || this.quesState === '4' || this.doFlag === '2') {
                    this.ywcFlag = true;
                } else {
                    this.ywcFlag = false;
                }

                if (this.doFlag === '0') {
                    for (let i = 0; i < this.infoData.teaInfo.length; i++) {
                        this.form._05.push([])
                        for (let j = 0; j < this.infoData.allQuestion.length; j++) {
                            this.form._05[i].push('')
                        }
                    }
                } else {
                    for (let i = 0; i < this.infoData.teaInfo.length; i++) {
                        this.form._05.push([])
                        for (let j = 0; j < this.infoData.allQuestion.length; j++) {
                            let t = this.infoData.allQuestion[j].answer.split("@");
                            this.form._05[i].push(t[i])
                        }
                    }
                }
                this.flag.infoFlag = true;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        //角色信息
        userInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                this.user.userName = res.data.data.name;
                this.user.userCode = res.data.data.phone;
                this.queryForm.userCode = res.data.data.phone;
                this.user.userRoles = Object.keys(res.data.data.roles).toString();
                if (this.user.userRoles === globalConfig.auth.xs) {
                    this.queryForm.role = 'stu'
                } else {
                    this.queryForm.role = 'tea'
                }
                this.initData()
            }).catch((err) => {
                console.log(err);
            });
        },
        showHomePage() {
            this.$router.push('/m/wx/home');
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                this.currentPage++;
                this.queryList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                //bottom top是相对于视口的左上角位置
                //bottom大于0或者top-视口高度小于0可见
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;
            this.queryForm.rowNum = this.limit;

            this.$api.evaluateManage.questionnaireSurvey.queryList({
                data: this.queryForm,
            }).then((response) => {
                // this.total = response.data.data.total;
                this.tableData = response.data.data;
                // this.tableData = this.tableData.concat(response.data.data);
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        handleFilter() {
            this.scrollToTop();
            this.tableData.length = 0;
            this.currentPage = 1;
            this.queryList();
            this.queryDialogVisible = false;
        },
        handleReset() {
            this.limit = 10;
            this.currentPage = 1;
            this.queryForm.SiteName = null;
            this.queryForm.SiteType = null;
            this.queryForm.AuditState = '';
            this.tableLoading = false;
            this.queryList();
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.limit = val;
            this.currentPage = 1;
            this.queryList();
        },
        initData() {
            this.$api.evaluateManage.questionnaireSurvey.initData({}).then((res) => {
                this.comboData.semester = res.data.data.semester
                this.queryForm.semesterCode = res.data.data.semNow
                this.queryList()
            }).catch((err) => {
                console.log(err);
            });
        },
        loadStateImg(row) {
            if (row.state === '0') {//未开始
                return require('image/mobile/auditState/wks.png');
            } else if (row.state === '1') {//进行中
                return require('image/mobile/auditState/jxz.png');
            } else if (row.state === '2') {//已完成
                return require('image/mobile/auditState/ywc.png');
            } else {//已结束
                return require('image/mobile/auditState/yjs.png');
            }
        },
        back() {
            this.doFlag = false
            this.clearFlag = false
            this.subFlag = false
            if (this.ywcFlag === true) {
                this.closeDialog()
                this.flag.infoFlag = false
            } else {
                this.$confirm('退出后数据不保存,是否确定退出?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'el-message-box-mobile',
                    type: 'warning'
                }).then(async () => {
                    this.closeDialog()
                    this.flag.infoFlag = false
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消此操作'
                    });

                    this.doFlag = '0'
                    this.clearFlag = true
                    this.subFlag = true
                });
            }
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
    },
};
</script>
<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode #queryArea {
    height: 40px;
    margin: 10px 0 10px 0;
}

#mobileMode #queryDialog {
    top: 150px;
}

#mobileMode #mainDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}

#mobileMode #listArea {
    height: calc(100% - 140px);
}

#mobileMode #listArea .cardText label {
    width: 100px;
    display: inline-block;
}

.el-dialog-div {
    height: 60vh;
    overflow: auto;
}

.attachmentUpload /deep/ .el-upload-dragger {
    width: 320px;
    height: 240px;
}

.maskStyle {
    width: 960px;
    overflow: hidden;
    background-color: #ffffff;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.3;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.xsyjDialog {
    top: 20vh;
}

.maskStyle {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: none;
    background-color: #000000;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.6;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.maskFont {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    width: 230px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -10px;
    margin-left: -90px;
}


#mobileMode #pfInputDialogScroll {
    height: 5vh;
}


#mobileMode #xzrMainDialogScroll {
    height: 75vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}

#mobileMode #pfMainDialogScroll {
    height: 65vh;
    padding: 0 20px 10px 20px;
}

#mobileMode .el-divider--horizontal {
    margin: 10px 0;
}

#mobileMode /deep/ .el-dialog {
    width: 96%;
    top: 2%;
    left: 2%;
}
</style>



// WEBPACK FOOTER //
// questionnaireSurveyMobile.vue?f649a310